<template>
    <div class="wrapper bind">
        <div class="title-main">
            <div class="title">
                <span class="title-h3">绑定账号</span>
                <span class="title-icon"></span>
            </div>
            <div class="title-p">绑定后可参加考试、学习、上传报告等</div>
        </div>
        <div class="bind-form">
            <div class="item-form">
                <label class="item-label">工作人员姓名</label>
                <div class="item-input-main">
                    <van-field class="item-input" v-model="name" placeholder="请输入" />
                </div>
            </div>
            <div class="item-form">
                <label class="item-label">工作人员身份证号</label>
                <div class="item-input-main">
                    <van-field class="item-input" v-model="id_card" placeholder="请输入" />
                </div>
            </div>
            <div class="item-form">
                <label class="item-label">手机号码</label>
                <div class="item-input-main">
                    <van-field class="item-input" v-model="mobile" placeholder="请输入" />
                </div>
            </div>
            <div class="item-form">
                <label class="item-label">图形验证码</label>
                <div class="item-input-main captcha-row">
                    <van-field
                        class="item-input captcha-field"
                        v-model="captchaCode"
                        placeholder="请输入验证码"
                        maxlength="10"
                    />
                    <div class="captcha-img-wrap" @click="fetchCaptcha">
                        <img v-if="captchaImage" :src="captchaImage" alt="验证码" class="captcha-img" />
                        <span v-else class="captcha-placeholder">{{ captchaLoading ? '加载中…' : '点击刷新' }}</span>
                    </div>
                </div>
            </div>
            <div class="form-btn">
                <van-button color="#4264CB" @click="submitClick" block>登录</van-button>
            </div>
        </div>
    </div>
</template>

<script>
import { getCaptcha, accountBinding } from '@/api/index'
import { setToken, clearWxMpAppId } from '@/utils/auth'
import { isMobile, isCard } from '@/utils/validate.js'
export default {
    components: {},
    props: {},
    data() {
        return {
            name: '',
            id_card: '',
            mobile: '',
            captchaKey: '',
            captchaCode: '',
            captchaImage: '',
            captchaLoading: false,
        };
    },
    computed: {
        openId() {
            const q = this.$route && this.$route.query
            if (q && q.openId) return String(q.openId)
            if (q && q.openid) return String(q.openid)
            return ''
        },
    },
    watch: {},
    created() {},
    mounted() {
        this.fetchCaptcha()
    },
    methods: {
        /**
         * GET /captcha/get 返回示例：
         * { captchaKey, captchaBase64: "data:image/png;base64,...", expireTime }
         */
        applyCaptchaRes(res) {
            const d = res && res.data
            if (d == null) return
            const payload =
                typeof d === 'object' && d.data !== undefined && typeof d.data === 'object'
                    ? d.data
                    : typeof d === 'object'
                      ? d
                      : {}
            this.captchaKey =
                payload.captchaKey ||
                payload.key ||
                payload.uuid ||
                payload.captchaId ||
                ''
            let img =
                payload.captchaBase64 ||
                payload.image ||
                payload.img ||
                payload.captchaImage ||
                payload.imageBase64 ||
                payload.base64 ||
                ''
            if (typeof img === 'string' && img && !img.startsWith('data:') && !/^https?:\/\//i.test(img)) {
                img = 'data:image/png;base64,' + img
            }
            this.captchaImage = typeof img === 'string' ? img : ''
        },
        fetchCaptcha() {
            if (this.captchaLoading) return
            this.captchaLoading = true
            this.captchaCode = ''
            getCaptcha()
                .then(res => {
                    this.applyCaptchaRes(res)
                })
                .finally(() => {
                    this.captchaLoading = false
                })
        },
        submitClick() {
            if (!this.name || !String(this.name).trim()) {
                this.$toast('请输入姓名')
                return
            }
            if (!isMobile(this.mobile)) {
                return
            }
            if (!isCard(this.id_card)) {
                return
            }
            if (!this.captchaKey) {
                this.$toast('请获取图形验证码')
                this.fetchCaptcha()
                return
            }
            if (!this.captchaCode || !String(this.captchaCode).trim()) {
                this.$toast('请输入图形验证码')
                return
            }
            if (!this.openId) {
                this.$toast('缺少微信标识，请从授权流程进入绑定页')
                return
            }
            const data = {
                captchaKey: this.captchaKey,
                captchaCode: String(this.captchaCode).trim(),
                openId: this.openId,
                name: String(this.name).trim(),
                phone: this.mobile,
                idCard: this.id_card,
            }
            accountBinding(data).then((res) => {
                const token = res && res.data
                if (token) {
                    setToken(token)
                }
                this.$toast('绑定成功')
                clearWxMpAppId()
                this.$router.replace({ path: '/' })
            }).catch(() => {
                this.fetchCaptcha()
            })
        },
    }
};
</script>
<style scoped>
.bind{
    box-sizing: border-box;
    padding: 0 24px;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg,#e8edff, rgba(255,255,255,0.00) 100%);
}
.title-main{
    padding-top: 24px;
}
.title{
    display: flex;
    align-items: center;
}
.title-h3{
    font-size: 20px;
    line-height: 28px;
}
.title-icon{
    margin-left: 8px;
    width: 20px;
    height: 20px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAABZdJREFUWEe9mGFoXEUQgGfevdBCC4lQMJIWUmjRQn+0oNCgxZbc7V7QosHaFizYIEKFiC0ULKj0REFFxIoV/RFIwZbWGqkQL8nuS5r4w6RCQxF/2B8FI+2FiC2kIDGl1x2ZY19YX97l3b0k7q97t7Mz35u3OzM7CP/DuHjxYtOaNWteAYBnAWAbADQBwAwAXEfEYc/zetrb2/+IQ8GV5guC4AUi6rFQ1czNAcDpUql0tKuri3/PjxUF1Fq/CQAf1uoEIrrh+37WteaKAWqt3wCAkw5cGQDOE9GQMabked7DiJgHgAMAsDqUI6JJ3/d3hZArAjg8PPySMeaMA/c37z8hxI9Rbw4MDKzPZDK9iJh15q6MjY3tLBQK5WUHDILgOSLqAwDfGuQ9lRVC/FTtU4+Ojvr3798/BwB7HZluIcQXywoYBIEkou+dTzaHiM/ncjmVtA97e3tXt7S0jALADpYlolvj4+Mblw1wKXAhvNb6aQC4HD4bYzqWBTAGrmw9V0zyXHReKXUTEddbLxaWDKi1fhIAhgCgbWgMEffmcrnv6oVj+SAI+omIAzqPniUBXrp06dFyuXzVhQOAI6KIz9LA8Rqt9dcAcNCuP5MacGRkpKVcLl8JPwcrRMRCLpd7Ny2cBRwPDwoAnEoNqLXmsMBBtjKWA66/v3/dqlWrbjpR4HAqwGKxuK2hoeGa46mvhBCvLcVzvFYp9QEiHg/1ZDKZ1lSAEUW3S6XShmiSZyPskYmJiRnOCEnw0UjA8VRK2ZkKUGv9KwBstUZPCSFejwIEQfAeEb0dza1xoFrrdgD4wQ3wxpgd+Xz+l7SA/4TKiOiAlPKbqGGt9V8AsM7Gsxt3797dvm/fPs7J/xlxYQoAjgkhPqns7STXV3ljCv/naJ/P5zkORg33AsChxfYpFwq+7/NerrxI3GFLC+h68KCU8mwU0ObWAACesnPlBw8ebO7o6JgMZZVSLyPi6fCZiN6XUr7j6loUcHBwsHV6eno6egC01vzWXLrzOC2E6Irz9NDQ0CbP835zKpv5T8fyttQa51hKRCellEejemIBC4WC39bW9i3nU97ks7Oz2zs7O/kOURlKqY8R8Zh9nLl3796mPXv23I6DVEr1I2IldRHRsJQy58qxp5ubm5tdzy7qQQt3jvNpKBjdZ0qprYjIJ7kyuP6TUr4YBxgEwVv86azcpJRyY5xctf8WeFBr/TkAdDvGJzOZzOPZbPaOqySaSeL2j/W2u89mhBAPpQYMY5cDd8sYszPO/e7+sfLXhRBbosbduwkXoVLKDakAo8UiEU0DwG4p5fVqCpVSj3GFhIjNAHA8jF3VPM0XJillR1pA92TOEdEuKeXPScp4kzc1Na12D1G4plgsFjc0NPzuZAh+iI+SdC44JAMDAzt83+cyJxxLqulCJe4JBoA5z/Nas9nsn3UDuieNWxKlUumRuORfj2Kl1KeIeMTZz7FxLkln5RRHTmSfECI2ZCQpC+djDtvk1NTUljQvHQLydW+XNRBbndQBd4KICm6YMsbsLhaIk/RWAJVSg7YNwY89QohXkxbGzQdBEIWbNsa0pYVjG6EHvwSAw9boVSHE/UCxvRibhPRzsXCVC02KoDRooxZnM+n79RiwK7fr8x5rwjz3VffrF2R126K4C2wcjxiruLnFtrDqhBEDxj2x1uL4bhFjSKaoVy5eZzsVLqBN/M6gkLy9HuSIKeB7xw4cLaxsbGa4i4yVnU53led1xwtV0s/qxhb6/mRlESVKwH7Wnm3Dpqc2sox3UgNx4vE9EdRGzh+7Bz6lkudS8mCXZBuWULAA47rUmL7TzDHUjbi0myEVtRc5L3fZ9T1XznIE4Rl0+IeEgIMZJkKO38oncS7iD4vr/ffk7em9zB4vjGDaO+qamps2nSVz2w/wIBm78rJi9T4QAAAABJRU5ErkJggg==) no-repeat;
    background-size: 100% 100%;
}
.title-p{
    margin-top: 8px;
    text-align: left;
    font-size: 14px;
    color: #999999;
}

.bind-form{
    margin-top: 40px;
}
.item-form{
    margin-top: 24px;
}
.item-form:first-child{
    margin-top: 0;
}
.item-label{
    display: block;
    margin-bottom: 8px;
    font-weight: 400;
    font-size: 14px;
}
.item-input-main{
    box-sizing: border-box;
    height: 50px;
    border: 1px solid #E8E8E8;
    display: flex;
    align-items: center;
}
.item-input{
    flex: 1;
    height: 100%;
}
.captcha-row{
    padding-right: 4px;
}
.captcha-field{
    min-width: 0;
}
.captcha-img-wrap{
    flex-shrink: 0;
    width: 100px;
    height: 40px;
    margin-right: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f5f5;
    border-radius: 4px;
    overflow: hidden;
}
.captcha-img{
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.captcha-placeholder{
    font-size: 12px;
    color: #4264CB;
    padding: 0 6px;
    text-align: center;
}
.form-btn{
    margin-top: 32px;
}
</style>
